import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import WellnessPlanTermsAndConditions from './membership/WellnessPlanTermsAndConditions'

const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      maxWidth: 856,
      margin: `${theme.spacing(3)} auto`,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 4,
      backgroundColor: theme.colors.tableBackground,
      boxShadow: '0 1px 4px 0 rgba(0,0,0,0.14)',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
    },
    title: {
      whiteSpace: 'pre-wrap',
      padding: theme.spacing(3, 5, 0),
      color: theme.colors.brandSecondary,
      fontSize: '2.6rem',
      fontWeight: 500,
      textAlign: 'left',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.6rem',
        padding: theme.spacing(2, 2, 0),
      },
    },
  }),
  { name: 'TermsAndConditionsScreen' },
)

const TermsAndConditionsScreen = () => {
  const classes = useStyles()

  const handleScroll = () => {}

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Terms and Conditions</Typography>
      <WellnessPlanTermsAndConditions onScroll={handleScroll} />
    </div>
  )
}

export default TermsAndConditionsScreen
